<script lang="js">
import { RouterLink } from 'vue-router';
import { mapGetters } from 'vuex';

export default {
  name: 'StaffSidebar',
  components: { RouterLink },
  data() {
    return {
      isDevelopment: process.env.NODE_ENV === "development",
    }
  },
  computed: {
    ...mapGetters(['getStaff']),
    allMenuItems() {
      // Use different routes for development vs production
      if (this.isDevelopment) {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/staff", module: "dashboard" },
          { name: "Academics", label: "Academics", icon: "bi bi-building-fill", route: "/staff/academics", module: "academics" },
          { name: "Exams", label: "Exams", icon: "bi bi-book", route: "/staff/exams", module: "exams" },
          { name: "Applications", label: "Applications", icon: "bi bi-file-earmark-text", route: "/staff/applications", module: "applications" },
          { name: "Admission Partners", label: "Admission Partners", icon: "bi bi-person-lines-fill", route: "/staff/admission-partners", module: "admissionPartners" },
          { name: "Students", label: "Students", icon: "bi bi-people", route: "/staff/students", module: "students" },
          { name: "Staffs", label: "Staffs", icon: "bi bi-person-badge", route: "/staff/staff", module: "staff" },
          { name: "Payments", label: "Payments", icon: "bi bi-cash-coin", route: "/staff/payments", module: "payments" },
          { name: "Utilities", label: "Utilities", icon: "bi bi-tools", route: "/staff/utilities", module: "utilities" },
          { name: "Reports", label: "Reports", icon: "bi bi-graph-up", route: "/staff/reports", module: "reports" },
          { name: "Scholarship", label: "Scholarship", icon: "bi bi-mortarboard", route: "/staff/scholarship", module: "scholarship" },
          { name: "Careers", label: "Careers", icon: "bi bi-folder-fill", route: "/staff/careers", module: "careers" },
          { name: "Notifications", label: "Notifications", icon: "bi bi-bell", route: "/staff/notifications", module: "notifications" },
           { name: "Database", label: "Database", icon: "bi bi-database", route: "/staff/database", module: "database" },
          { name: "Settings", label: "Settings", icon: "bi  bi-gear", route: "/staff/settings", module: "settings" }
        ];
      } else {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/dashboard", module: "dashboard" },
          { name: "Academics", label: "Academics", icon: "bi bi-building-fill", route: "/academics", module: "academics" },
          { name: "Exams", label: "Exams", icon: "bi bi-book", route: "/exams", module: "exams" },
          { name: "Applications", label: "Applications", icon: "bi bi-file-earmark-text", route: "/applications", module: "applications" },
          { name: "Admission Partners", label: "Admission Partners", icon: "bi bi-person-lines-fill", route: "/admission-partners", module: "admissionPartners" },
          { name: "Students", label: "Students", icon: "bi bi-people", route: "/students", module: "students" },
          { name: "Staffs", label: "Staffs", icon: "bi bi-person-badge", route: "/staff", module: "staff" },
          { name: "Reports", label: "Reports", icon: "bi bi-graph-up", route: "/reports", module: "reports" },
          { name: "Payments", label: "Payments", icon: "bi bi-cash-coin", route: "/payments", module: "payments" },
          { name: "Utilities", label: "Utilities", icon: "bi bi-tools", route: "/utilities", module: "utilities" },
          { name: "Scholarship", label: "Scholarship", icon: "bi bi-mortarboard", route: "/scholarship", module: "scholarship" },
          { name: "Careers", label: "Careers", icon: "bi bi-folder-fill", route: "/careers", module: "careers" },
          { name: "Notifications", label: "Notifications", icon: "bi bi-bell", route: "/notifications", module: "notifications" },
                    { name: "Database", label: "Database", icon: "bi bi-database", route: "/database", module: "database" },
          { name: "Settings", label: "Settings", icon: "bi  bi-gear", route: "/settings", module: "settings" }
        ];
      }
    },
    menuItems() {
      // Always show Dashboard, Reports and Settings regardless of permissions
      const dashboardItem = this.allMenuItems.find(item => item.name === "Dashboard");
      const reportsItem = this.allMenuItems.find(item => item.name === "Reports");
      const settingsItem = this.allMenuItems.find(item => item.name === "Settings");

      // If no staff data, only show Dashboard, Reports and Settings
      if (!this.getStaff) {
        return [dashboardItem, reportsItem, settingsItem].filter(Boolean);
      }

      // Filter menu items using the hasModule permission getter
      return this.allMenuItems.filter(item => {
        if (item.name === "Dashboard" || item.name === "Reports" || item.name === "Settings") return true;
        return this.$store.getters.hasModule(item.module);
      });
    }
  },
  methods: {
    isActive(routePath) {
      return this.$route.path === routePath;
    },
  },
  mounted() {},
  created: function () { }
}
</script>
<template>
  <div
    class="sidebar bg-light border-end d-none d-lg-flex flex-column align-items-center overflow-scroll"
  >
    <ul class="nav flex-column w-100 text-center">
      <li
        v-for="item in menuItems"
        :key="item.name"
        class="nav-item w-100 p-3"
        :class="{ active: $route.path === item.route }"
      >
        <RouterLink
          class="nav-link d-flex flex-column align-items-center text-dark"
          :to="item.route"
        >
          <i :class="item.icon + ' fs-4'"></i>
          <span class="small">{{ item.label }}</span>
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.sidebar ul li.active {
  color: #fff !important;
  background-color: #181c1f !important;
}

.sidebar ul li.active i,
.sidebar ul li.active span {
  color: #fff !important;
}
</style>
